import {css, html, render} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import AuthorizationFilter from '../Authorization/AuthorizationFilter'
import BerechtigteListService from '../../services/BerechtigteListService'
import EinladungService from '../Einladung/EinladungService'
import EinladungColumns from '../Einladung/EinladungColumns'
import EinladungDto from '../Einladung/EinladungDto'
import GPDto from '../Geschaeftspartner/GPDto'
import {List} from '@isceco/widget-library2/basic-elements/List/List'
import BenutzerService from "../Benutzer/BenutzerService";
import BenutzerDto from "../Benutzer/BenutzerDto";
import BenutzerColumns from "../Benutzer/BenutzerColumns";

import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput.js'
import '@isceco/widget-library2/basic-elements/Checkbox/Checkbox.js'
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown'

export default class GPBenutzer extends WebComponent {
  static get I18N_KEYS() {
    return {
      CANCEL_BUTTON: 'base.button.cancel',
      CONFIRM_BUTTON: 'base.button.confirm'
    }
  }

  static get properties() {
    return {
      geschaeftspartner: {type: GPDto}
    }
  }

  constructor() {
    super()
    this.einladungService = new EinladungService('gp', getNavigationId())
    this.benutzerService = new BenutzerService('gp', getNavigationId())
    this.showDialogCreateEinladung = false
    this.showDialogDeleteEinladung = false
    this.showArchivedBenutzer = false
  }

  get translationFile() {
    return './views/GPDetail/i18n.json'
  }

  get css() {
    return css`
      .post-address {
        padding-top: 10px;
        font-size: 1.05em;
        font-weight: bold;
        color: black;
      }

      #edit-benutzer-dialog {
        --form-align: 30%;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.einladungService.getBackendListUrl(),
      this.benutzerService.getBackendListUrl()
    ]).then(([einladungUrl, benutzerUrl]) => {
      this.einladungUrl = einladungUrl
      this.benutzerUrl = benutzerUrl
    }).catch(_ => {
      this.einladungUrl = ''
      this.benutzerUrl = ''
    }).finally(() =>
      this.render()
    )
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('gp.einladung.title')}">
        <isceco-button size="small" icon="plus" variant="primary"
                       text="${this.i18n.translate('einladung.create.title')}"
                       @click="${_ => this.toggleDialogEinladungCreate(true)}"
        ></isceco-button>
      </isceco-title>
      ${this._renderEinladung()}
      <isceco-title size="medium" text="${this.i18n.translate('gp.benutzer.title')}">
        <isceco-button size="small"
                       text="${this.i18n.translate(this.showArchivedBenutzer ? 'benutzer.archived.button.hide' : 'benutzer.archived.button.show')}"
                       icon="${this.showArchivedBenutzer ? 'eye outline slash' : 'eye outline'}"
                       @click="${_ => this.toggleArchivedBenutzer()}"
        ></isceco-button>
      </isceco-title>
      ${this._renderBenutzer()}
    `
  }

  _renderEinladung() {
    return html`
      <isceco-list id="einladung-list" identifier="einladung"
                   url="${this.einladungUrl}"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toEinladungDto}"
                   .columns="${this.getEinladungColumns()}"
      ></isceco-list>
      ${this._renderDialogCreateEinladung()}
      ${this._renderDialogConfirmDeleteEinladung()}
    `
  }

  _renderDialogCreateEinladung() {
    if (this.showDialogCreateEinladung) {
      if (new AuthorizationFilter().roles.GP_SUPERUSER) {
        return this._renderEinladungEmailDialog()
      } else {
        return this._renderEinladungPostalDialog()
      }
    } else {
      return html``
    }
  }

  _renderEinladungPostalDialog() {
    return html`
      <isceco-dialog id="einladung-create-dialog"
                     header="${this.i18n.translate('einladung.create.dialog.title.brief')}"
                     description="${this.i18n.translate('einladung.create.dialog.text.post')}"
                     confirm-button="${this.i18n.translate('einladung.create.dialog.submit.post')}"
                     cancel-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                     @submit="${e => this._handleEinladungCreate(e.detail)}"
      >
        <div class="form-row post-address">
          ${this.geschaeftspartner.name}<br>
          ${this.geschaeftspartner.strasse} ${this.geschaeftspartner.zusatz}<br>
          ${this.geschaeftspartner.plz} ${this.geschaeftspartner.ort}
        </div>
        <isceco-checkbox name="confirmation" required
                         label="${this.i18n.translate('einladung.create.dialog.checkbox.title')}"
        ></isceco-checkbox>
      </isceco-dialog>
    `
  }

  _renderEinladungEmailDialog() {
    return html`
      <isceco-dialog id="einladung-create-dialog"
                     header="${this.i18n.translate('einladung.create.dialog.title.email')}"
                     description="${this.i18n.translate('einladung.create.dialog.text.email')}"
                     confirm-button="${this.i18n.translate('einladung.create.dialog.submit.email')}"
                     cancel-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                     @submit="${e => this._handleEinladungCreate(e.detail)}"
      >
        <isceco-text-input name="email" type="email"
                           required style="padding: 10px 0"
                           value="${this.email}"
                           label="${this.i18n.translate('einladung.create.dialog.input.title')}"
                           pattern-error-text="${this.i18n.translate('einladung.create.dialog.input.error')}"
        ></isceco-text-input>
      </isceco-dialog>
    `
  }

  _renderDialogConfirmDeleteEinladung() {
    if (this.showDialogDeleteEinladung) {
      return html`
        <isceco-dialog id="delete-invitation-dialog"
                       header="${this.i18n.translate('einladung.delete.dialog.title')}"
                       description="${this.i18n.translate('einladung.delete.dialog.description')}"
                       confirm-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CONFIRM_BUTTON)}"
                       cancel-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${e => this._handleEinladungDelete(e.detail)}"
        ></isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _renderBenutzer() {
    return html`
      <isceco-list id="benutzer-list" identifier="benutzer"
                   .listService="${BerechtigteListService}"
                   url="${this.benutzerUrl}"
                   .defaultFilters="${{archived: this.showArchivedBenutzer}}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toBenutzerDto}"
                   .columns="${BenutzerColumns.getGpColumns(this.showArchivedBenutzer, this.benutzerDeleteCallback, this.benutzerEditCallback)}"
                   sort="nachname" order="asc"
      ></isceco-list>
      ${this._renderDialogConfirmEditBenutzer()}
      ${this._renderDialogConfirmDeleteBenutzer()}
    `
  }

  _renderDialogConfirmEditBenutzer() {
    if (this.benutzerToEdit) {
      return html`
        <isceco-dialog id="edit-benutzer-dialog"
                       header="${this.i18n.translate('benutzer.edit.dialog.title')}"
                       confirm-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CONFIRM_BUTTON)}"
                       cancel-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${e => this._handleBenutzerEdit(e.detail)}">
          <isceco-text-input label="${this.i18n.translate('benutzer.edit.dialog.extId')}" value="${this.benutzerToEdit.extId}" inline readonly></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('benutzer.edit.dialog.name')}" value="${this.benutzerToEdit.name}" inline readonly></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('benutzer.edit.dialog.email')}" value="${this.benutzerToEdit.email}" inline readonly></isceco-text-input>
          <isceco-dropdown name="berechtigung" inline required
                           label="${this.i18n.translate('benutzer.edit.dialog.berechtigung')}"
                           value="${this.benutzerToEdit.berechtigung}"
                           .items="${[
                             { value: 'USER', name: this.i18n.translate('benutzer.berechtigung.user') },
                             { value: 'SUPERUSER', name: this.i18n.translate('benutzer.berechtigung.superuser') }
                           ]}"
          ></isceco-dropdown>
        </isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _renderDialogConfirmDeleteBenutzer() {
    if (this.benutzerToDelete) {
      return html`
        <isceco-dialog id="delete-benutzer-dialog"
                       header="${this.i18n.translate('benutzer.delete.dialog.title', this.benutzerToDelete)}"
                       description="${this.i18n.translate('benutzer.delete.dialog.description', this.benutzerToDelete)}"
                       confirm-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CONFIRM_BUTTON)}"
                       cancel-button="${this.i18n.translate(GPBenutzer.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${e => this._handleBenutzerDelete(e.detail)}"
        ></isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _handleEinladungDelete = event => {
    if (event.confirmed) {
      this.einladungService.delete(this.einladungToDelete?.id)
        .then(_ => {
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'einladung'})
          this.einladungToDelete = null
          this.showDialogDeleteEinladung = false
          this.render()
        })
    } else {
      this.einladungToDelete = null
      this.showDialogDeleteEinladung = false
      this.render()
    }
  }

  _handleEinladungCreate = event => {
    if (!event.confirmed) {
      this.toggleDialogEinladungCreate(false)
      return
    }
    let einladung = null
    // email einladung
    const einladungEmail = document.querySelector('#einladung-create-dialog isceco-text-input[name=email]')
    if (einladungEmail && einladungEmail.validate()) {
      einladung = {email: einladungEmail.getValue()}
    }
    // briefliche einladung
    const einladungCheckbox = document.querySelector('#einladung-create-dialog isceco-checkbox[name=confirmation]')
    if (einladungCheckbox && einladungCheckbox.validate()) {
      einladung = {
        name: this.geschaeftspartner.name,
        strasse: this.geschaeftspartner.strasse,
        zusatz: this.geschaeftspartner.zusatz,
        plz: this.geschaeftspartner.plz,
        ort: this.geschaeftspartner.ort
      }
    }
    if (einladung) {
      this.einladungService.create(einladung)
        .then(created => {
          window.showAlert(this.i18n.translate(`einladung.create.alert.success.${this.email ? 'email' : 'post'}`, {empfaenger: created.empfaenger}), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'einladung'})
        })
      this.toggleDialogEinladungCreate(false)
    }
  }

  _handleBenutzerEdit = event => {
    if (event.confirmed) {
      const payload = { id: this.benutzerToEdit.uuid }
      const benutzerBerechtigung = document.querySelector('#edit-benutzer-dialog isceco-dropdown[name=berechtigung]')
      if (benutzerBerechtigung.validate()) {
        payload.berechtigung = benutzerBerechtigung.getValue()
      }
      this.benutzerService.update(payload)
        .then(response => {
          const benutzer = new BenutzerDto(response)
          window.showAlert(this.i18n.translate(`benutzer.edit.alert.success`, {
            name: benutzer.name,
            role: this.i18n.translate(benutzer.role)
          }), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'benutzer'})
        })
        .finally(_ => {
          this.benutzerToEdit = null
          this.render()
        })
    } else {
      this.benutzerToEdit = null
      this.render()
    }
  }

  _handleBenutzerDelete = event => {
    if (event.confirmed) {
      this.benutzerService.delete(this.benutzerToDelete.uuid)
        .then(_ => {
          window.showAlert(this.i18n.translate(`benutzer.delete.alert.success`, {name: this.benutzerToDelete.name}), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'benutzer'})
        })
        .finally(_ => {
          this.benutzerToDelete = null
          this.render()
        })
    } else {
      this.benutzerToDelete = null
      this.render()
    }
  }

  einladungDeleteCallback = row => {
    this.einladungToDelete = row
    this.showDialogDeleteEinladung = true
    this.render()
  }

  einladungDownloadCallback = row =>  {
    const fileName = `${this.i18n.translate('einladung.pdf.file.name')}${this.geschaeftspartner.name}`
    this.einladungService.read(row.id, 'pdf')
      .then(response => response.blob())
      .then(blob => download(toValidFilename(fileName, 'pdf'), blob))
  }

  benutzerEditCallback = row => {
    this.benutzerToEdit = row
    this.render()
  }

  benutzerDeleteCallback = row => {
    this.benutzerToDelete = row
    this.render()
  }

  toggleDialogEinladungCreate(show) {
    this.showDialogCreateEinladung = show
    this.reload()
  }

  toggleArchivedBenutzer() {
    this.showArchivedBenutzer = !this.showArchivedBenutzer
    // Update der Liste forcieren, indem wir sie zunächst löschen
    render(html``, this.root)
    this.render()
  }

  getEinladungColumns() {
    const roles = new AuthorizationFilter().roles
    if (roles.BWL || roles.OSTRAL || roles.VNB) {
      return EinladungColumns.getColumnsWithDownload(this.einladungDeleteCallback, this.einladungDownloadCallback)
    }
    return EinladungColumns.getColumns(this.einladungDeleteCallback)
  }

  toEinladungDto = row => new EinladungDto(row)
  toBenutzerDto = row => new BenutzerDto(row)
}

customElements.define('eko-frontend-gp-detail-benutzer', GPBenutzer)
